import { render, staticRenderFns } from "./CommentTextarea.vue?vue&type=template&id=8d1220e6&scoped=true&"
import script from "./CommentTextarea.vue?vue&type=script&lang=js&"
export * from "./CommentTextarea.vue?vue&type=script&lang=js&"
import style0 from "./CommentTextarea.vue?vue&type=style&index=0&id=8d1220e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1220e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VRow,VTextarea})
